import React from 'react'

import { Box, Typography } from '@material-ui/core'
import { FileText, Download } from 'react-feather'
import { isEmpty } from 'lodash'

import useStyles from './styles'

const LessonAttachments = ({ attachments }) => {
  const classes = useStyles()

  if (isEmpty(attachments)) return null

  return (
    <Box className={classes.root}>
      <Typography className={classes.title}>Anexos</Typography>
      <Box className={classes.list}>
        {attachments.map((attachment) => (
          <Box
            key={attachment.id}
            component="a"
            href={attachment.url}
            target="_blank"
            rel="noopener noreferrer"
            download={attachment.filename}
            className={classes.pill}
          >
            <FileText size={14} className={classes.fileIcon} />
            {attachment.filename}
            <Download size={14} className={classes.downloadIcon} />
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default LessonAttachments
